<template>
    <div class="globalSet">
        <el-tabs v-model="activeNames">
            <el-tab-pane label="单位设置" name="unit">
                <el-form :inline="true" class="unit-form content-form">
                    <el-form-item :label="item.title+'：'" v-for="item in unit" :key="item.name">
                        <el-select v-model="item.default" :placeholder="item.title">
                            <el-option :label="d" :value="d" v-for="d of item.values" :key="d"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </el-tab-pane>

            <!--节点显示字段设置-->
            <el-tab-pane label="节点显示" name="node">
                <div class="table-title">
                    表格显示设置
                </div>
                <el-table
                    :data="nodeFiledTable"
                    border
                    style="width: 100%"
                    max-height="200"
                    class="node-table field-table"
                    header-row-class-name="node-header field-header"
                    row-class-name="node-row field-row"
                    cell-class-name="node-cell field-cell">

                    <el-table-column
                        prop="title"
                        label="名称"
                        width="100">
                    </el-table-column>

                    <el-table-column
                        width="100"
                        label="是否显示">
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.t_show"></el-checkbox>
                        </template>
                    </el-table-column>

                    <el-table-column
                        label="有效位">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.t_precision" placeholder="输入数值" class="precision" type="number" :disabled="!scope.row.t_precision"/>
                        </template>
                    </el-table-column>

                    <el-table-column
                        label="小数位">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.t_length" placeholder="输入数值" class="precision" type="number" :disabled="!scope.row.t_length"/>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="table-title">
                    绘图显示设置
                </div>

                <el-table
                    :data="nodeFiledTable"
                    border
                    style="width: 100%"
                    class="pipe-table field-table"
                    header-row-class-name="pipe-header field-header"
                    row-class-name="pipe-row field-row"
                    max-height="200"
                    cell-class-name="pipe-cell field-cell">

                    <el-table-column
                        prop="title"
                        label="名称"
                        width="100">
                    </el-table-column>

                    <el-table-column
                        width="100"
                        label="是否显示">
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.g_show"></el-checkbox>
                        </template>
                    </el-table-column>

                    <el-table-column
                        label="有效位">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.g_precision" placeholder="输入数值" class="precision" type="number" :disabled="!scope.row.g_precision"/>
                        </template>
                    </el-table-column>

                    <el-table-column
                        label="小数位">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.g_length" placeholder="输入数值" class="precision" type="number" :disabled="!scope.row.g_length"/>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>

            <!--管道显示字段设置-->
            <el-tab-pane label="管道显示" name="pipe">
                <div class="table-title">
                    表格显示设置
                </div>
                <el-table
                    :data="pipeFiledTable"
                    border
                    style="width: 100%"
                    max-height="200"
                    class="node-table field-table"
                    header-row-class-name="node-header field-header"
                    row-class-name="node-row field-row"
                    cell-class-name="node-cell field-cell">

                    <el-table-column
                        prop="title"
                        label="名称"
                        width="100">
                    </el-table-column>

                    <el-table-column
                        width="100"
                        label="是否显示">
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.t_show"></el-checkbox>
                        </template>
                    </el-table-column>

                    <el-table-column
                        label="有效位">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.t_precision" placeholder="输入数值" class="precision" type="number" :disabled="!scope.row.t_precision"/>
                        </template>
                    </el-table-column>

                    <el-table-column
                        label="小数位">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.t_length" placeholder="输入数值" class="precision" type="number" :disabled="!scope.row.t_length"/>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="table-title">
                    绘图显示设置
                </div>

                <el-table
                    :data="pipeFiledTable"
                    border
                    style="width: 100%"
                    class="pipe-table field-table"
                    header-row-class-name="pipe-header field-header"
                    row-class-name="pipe-row field-row"
                    max-height="200"
                    cell-class-name="pipe-cell field-cell">

                    <el-table-column
                        prop="title"
                        label="名称"
                        width="100">
                    </el-table-column>

                    <el-table-column
                        width="100"
                        label="是否显示">
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.g_show"></el-checkbox>
                        </template>
                    </el-table-column>

                    <el-table-column
                        label="有效位">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.g_precision" placeholder="输入数值" class="precision" type="number" :disabled="!scope.row.g_precision"/>
                        </template>
                    </el-table-column>

                    <el-table-column
                        label="小数位">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.g_length" placeholder="输入数值" class="precision" type="number" :disabled="!scope.row.g_length"/>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>

        <div class="foot-btn">
            <el-button size="medium" @click="setCompleted" type="primary">确认</el-button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import _remove from "lodash/remove";
import _filter from "lodash/filter";

import {water,unit} from "../PipeEditor/FileFormat"; // 水配置文件

export default {
    name:"overHeadParamSet",
    computed:{
        ...mapState('simulation',[
            'globalSet',
        ])
    },
    watch:{
        globalSet:{
            handler(){
                this.init_data();
            },
            deep:true
        }
    },
    data(){
        return {
            activeNames:'unit', // 打开的面板

            nodeFiledTable:[{
                "name": "press",
                "title": "压力",
                "t_show": true,
                "g_show": true,
                "t_precision": 3,
                "t_length": 4,
                "g_precision": 3,
                "g_length": 4
            }, {
                "name": "flux",
                "title": "流量",
                "t_show": true,
                "g_show": true,
                "t_precision": 3,
                "t_length": 4,
                "g_precision": 3,
                "g_length": 4
            }], // 字段显示表格设置

            pipeFiledTable:[{
                "name": "flux",
                "title": "流量",
                "t_show": true,
                "g_show": true,
                "t_precision": 3,
                "t_length": 4,
                "g_precision": 3,
                "g_length": 4
            }, {
                "name": "velocity",
                "title": "流速",
                "t_show": true,
                "g_show": true,
                "t_precision": 3,
                "t_length": 4,
                "g_precision": 3,
                "g_length": 4
            }, {
                "name": "pressLoss",
                "title": "压损",
                "t_show": true,
                "g_show": true,
                "t_precision": 3,
                "t_length": 4,
                "g_precision": 3,
                "g_length": 4
            }], // 字段显示表格设置

            unit:unit, // 单位设置
 
        }
    },
    mounted(){
        this.init_data();
    },
    methods:{
        // 初始化数据
        init_data(){
            // 获取节点字段
            let nodeHeader=this.globalSet.nodeHeader;
            if(nodeHeader){
                let nodeFiledTable=Object.values(nodeHeader);
                // 去掉id号
                nodeFiledTable=_filter(nodeFiledTable, function(o) { 
                    return o.name!="id"; 
                });

                this.nodeFiledTable=nodeFiledTable;

            }
            // 获取管道字段
            let pipeHeader=this.globalSet.pipeHeader;
            if(pipeHeader){
                let pipeFiledTable=Object.values(pipeHeader);
                // 去掉id号
                pipeFiledTable=_filter(pipeFiledTable, function(o) { return o.name!="id"; });

                this.pipeFiledTable=pipeFiledTable;
            }
        },
        // 设置完成
        setCompleted(){
            // 保存单位设置
            let wunit=water.unit;
            let header=wunit.header;
            header=[];
            let data=wunit.data;
            data=[];
            let tdata=[];
            for(let n in this.unit){
                let item=this.unit[n];
                header.push(item.name);
                tdata.push(item.default);
            }
            // 这里不知道为什么，后台必须这么设置[[]]
            data.push(tdata);
            // 保存用户设置
            this.globalSet.unit=wunit;

            // 关闭对话框
            this.$emit("close");
        },
        // 全局方案修改
        globalSuggestionChange(){
            let temp=JSON.parse(JSON.stringify(this.globalConfig));
            temp.insulaMaterialSugs=this.suggestions;
            this.$store.commit("simulation/setGlobalConfig",temp);
            // 后台保存用户配置
            this.$store.dispatch("simulation/saveGlobalConfig",temp);
        },
    }
}
</script>

<style lang="scss" scoped>
.globalSet{
    // 最后一个模块不显示底部边框
    .el-collapse-item:last-child{
        ::v-deep .el-collapse-item__wrap{
            border-bottom: none;
        }
    }

    .content-form{
        padding:0 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
    }
    // 节点表格
    .table-title{
        margin:5px 0;
    }
    ::v-deep .field-table{
        .field-header{
            th{
                text-align: center;
                background: cornflowerblue;
                color: #fff;
            }

        }
        .field-cell{
            text-align: center;
            padding: 5px;

            .cell{
                padding:0;
            }
            .el-input{
                width: 100%;

                .el-input__inner{
                    padding:0 5px;
                }
            }
        }
    }
}
</style>
